export class AdbScrcpyOptionsBase {
    raw;
    get value() {
        return this.raw.value;
    }
    set value(value) {
        this.raw.value = value;
    }
    constructor(raw) {
        this.raw = raw;
    }
    getDefaultValue() {
        return this.raw.getDefaultValue();
    }
    formatServerArguments() {
        return this.raw.formatServerArguments();
    }
    getOutputEncoderNameRegex() {
        return this.raw.getOutputEncoderNameRegex();
    }
    createVideoStreamTransformer() {
        return this.raw.createVideoStreamTransformer();
    }
    getControlMessageTypes() {
        return this.raw.getControlMessageTypes();
    }
    serializeBackOrScreenOnControlMessage(message) {
        return this.raw.serializeBackOrScreenOnControlMessage(message);
    }
    serializeSetClipboardControlMessage(message) {
        return this.raw.serializeSetClipboardControlMessage(message);
    }
    getScrollController() {
        return this.raw.getScrollController();
    }
}
//# sourceMappingURL=types.js.map